var _rect, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    rx: 29,
    fill: "#D3C9FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.019 23.9139L19.9693 23.9428V34.0194L15 36.9641V20.9948L15.0497 20.9658L20.019 23.9139Z",
    fill: "#A793F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5745 39.0204V44.9165L28.4752 44.9761L15 36.9829V36.9642L19.9693 34.0195V34.0349L28.4752 39.08L28.5745 39.0204Z",
    fill: "#A793F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9486 36.9237V36.9832L28.5745 44.9169V39.0207L36.9793 34.0352V33.9756L41.9486 36.9237Z",
    fill: "#A793F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9486 20.998V36.9231L36.9793 33.9751V23.9427L41.9486 20.998Z",
    fill: "#A793F6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9486 20.9949V20.9983L36.9793 23.943L28.5745 18.9557V13.0596L41.9486 20.9949Z",
    fill: "#A793F6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5745 13.0596V18.9557L28.4751 18.8962L20.019 23.914L15.0497 20.966L28.4751 13L28.5745 13.0596Z",
    fill: "#A793F6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountAvatar);
export default __webpack_public_path__ + "static/media/account-avatar.a574a1ebb7b8d5f5dbcd15c46efdfbc4.svg";
export { ForwardRef as ReactComponent };